import { formatDate } from '@angular/common';
import { isValid } from 'date-fns';

import { I18nLocaleFactory } from '../../../i18n/i18n.module';
import { I18nService } from '../../../i18n/i18n.service';
import { epicDependencies } from '../../../store';

export function formatRawDate(start: Date, end: Date): string {
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);

    if (!isValid(start) || !isValid(end)) {
        return '';
    }

    const locale = I18nLocaleFactory(i18nService);
    const parts: string[] = [
        formatDate(start, 'MMM dd y', locale),
        formatDate(end, 'MMM dd y', locale),
    ];

    return parts.join(' - ');
}
